module.exports = __webpack_public_path__ + "static/img/211.ca050966.jpg";